import React, { useState, useEffect } from "react";
import { BarChartSharp } from '@mui/icons-material';
import JBrowseService from "../services/jbrowse.service";
import { toast } from 'react-toastify';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import CircularProgress from '@mui/material/CircularProgress';

const BigWigModal = (props) => {
    const { 
        setBigWigModalIsOpen,
        setLoading,
        currentUser,
        selectedCrop,
        setSelectedTracks,
        selectedTracks,
    } = props;

    const [bigWigTracks, setBigWigTracks] = useState([]);
    const [selectedTrackId, setSelectedTrackId] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const closeModal = () => {
        setBigWigModalIsOpen(false);
    };

    useEffect(() => {
        if (currentUser) {
            console.log("currentUser: ", currentUser);
            const obj = {
                user: currentUser.email,
                crop: selectedCrop,
                directory: currentUser.DirectoryName,
            };
            console.log('Requesting BigWig tracks with: ', obj);
            setIsLoading(true);
            JBrowseService.getBigWigTracks(obj).then(
                (response) => {
                    console.log("BigWig tracks response: ", response);
                    setTimeout(() => {
                        if (response.status === 0 && response.data) {
                            setBigWigTracks(response.data);
                        } else {
                            console.log("No BigWig tracks found.");
                        }
                        setIsLoading(false);
                    },1000);
                },
                (error) => {
                    console.log("Error fetching BigWig tracks: ", error);
                    setIsLoading(false);
                }
            );
        }
    }, [currentUser, selectedCrop]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setBigWigModalIsOpen(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleTrackChange = (event) => {
        const selectedId = event.target.value;
        setSelectedTrackId(selectedId);
        const selectedObject = bigWigTracks.find(track => track.BigWig_idBigWig === parseInt(selectedId));
        let track = selectedObject.BigWig_FileName;
        console.log("track: ", track );
        setSelectedTracks(prevTracks => prevTracks.includes(track) ? prevTracks : [...prevTracks, track]);
        console.log("selected tracks: ", selectedTracks );
        toast.success("Added a BigWig Track.");
    };

    return (
        <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
                <div className="relative w-11/12 max-w-2xl p-6 bg-white rounded-xl shadow-xl md:w-3/4 lg:w-1/2 border border-gray-200">
                    <div className="flex items-center justify-between mb-6">
                        <h5 className="text-xl font-semibold flex items-center text-gray-800">
                            <BarChartSharp className="mr-2 text-emerald-600" /> 
                            <span>Select BigWig Tracks</span>
                        </h5>
                        <button 
                            type="button" 
                            className="text-gray-500 hover:text-gray-700 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100"
                            onClick={closeModal}
                            aria-label="Close"
                        >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                    <div className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100" style={{ maxHeight: '70vh' }}>
                        {isLoading ? (
                            <div className="flex justify-center items-center py-10">
                                <CircularProgress className="text-blue-600" />
                            </div>
                        ) : (
                            bigWigTracks.length > 0 ? (
                                <div className="mb-4">
                                    <label htmlFor="bigwig-track-select" className="block text-sm font-medium text-gray-700 mb-2">
                                        BigWig Tracks
                                    </label>
                                    <div className="relative">
                                        <select
                                            id="bigwig-track-select"
                                            value={selectedTrackId}
                                            onChange={handleTrackChange}
                                            className="block w-full pl-3 pr-10 py-3 text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-lg shadow-sm appearance-none bg-white text-gray-700"
                                            aria-label="BigWig Tracks"
                                        >
                                            <option value="">Select a track</option>
                                            {bigWigTracks.map((track, key) => (
                                                <option key={key} value={track.BigWig_idBigWig}>
                                                    {track.ExternalID}
                                                </option>
                                            ))}
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="py-4">
                                    <Alert 
                                        icon={<CheckIcon fontSize="inherit" />} 
                                        severity="warning"
                                        className="rounded-lg shadow-sm"
                                    >
                                        No BigWig tracks available for the selected crop.
                                    </Alert>
                                </div>
                            )
                        )}
                    </div>
                    <div className="flex justify-end mt-6 pt-4 border-t border-gray-100">
                        <button
                            className="px-5 py-2.5 text-white bg-gray-700 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200 shadow-sm font-medium"
                            onClick={closeModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BigWigModal;
